import { savePersonalizeExperience } from "../../../../app/api/getSpecialAssistancePref";
import { BaseAction } from "../../../../core/actions/BaseAction";
import { getUserDetailsAction } from "../GetUserDetailsAction";
import { invalidateUserCaches } from "../invalidateUserCaches";


interface IUpdateRailPreferenceParams {
    payload: any, userId: number
}

class UpdateRailPreferenceAction extends BaseAction<void, IUpdateRailPreferenceParams> {
    override async run(): Promise<void> {
        try {
            const { payload, userId } = this.params!;
            const response: any = await savePersonalizeExperience(payload, userId);
            if (response.status === "ok" && response.answer) {
                // Drop the stale session caches first; otherwise execute() just
                // replays the pre-save user from _cachedUser instead of fetching
                // the updated record.
                invalidateUserCaches();
                await getUserDetailsAction.execute();
            } else {

            }
        } catch (error) {
            
        }

    }
}

export const updateRailPreferenceAction = new UpdateRailPreferenceAction();
